<script lang="ts">
  import type { Snippet } from 'svelte'

  type Props = {
    left?: Snippet
    right?: Snippet
  }

  let { left, right }: Props = $props()
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
  class="flex items-center justify-between px-4 h-7 mb-2 mt-1 overflow-visible"
  onclick={(e) => e.stopPropagation()}
>
  <div class="pmd:gap-4 gap-2 flex items-center h-7 w-fit">
    {@render left?.()}
  </div>
  <div class="pmd:gap-4 gap-2 flex items-center justify-end h-7 w-fit">
    {@render right?.()}
  </div>
</div>
